function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.96 30.04a24.953 24.953 0 01-24.953 24.953A24.953 24.953 0 013.054 30.04 24.953 24.953 0 0128.007 5.087 24.953 24.953 0 0152.96 30.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.251 11.04c1.827 4.565 3.003 11.032 3.003 19.047 0 7.758-1.102 14.69-2.83 19.266M44.088 11.04c-1.827 4.565-3.003 11.032-3.003 19.047 0 7.758 1.102 14.69 2.83 19.266"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.453 5.14v49.906M52.405 30.04H2.5"
}));

var SvgBasketball = function SvgBasketball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasketball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Basketball.0dbc696f.svg";
export { ForwardRef as ReactComponent };